module.exports = __webpack_public_path__ + "static/img/100_own_einstiegsleiste_vw_offroad.01b218d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_own_einstiegsleiste_vw_offroad.jpeg
// module id = NB/u
// module chunks = 1